import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, CircularProgress } from '@mui/material';
import { X } from 'phosphor-react';
import { deleteAlerts } from 'js/library/utils/API/deleteAlerts';
import { toast } from 'react-toastify';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90%', // Definindo um tamanho máximo para caber em telas pequenas
  width: 'auto', // O modal irá se ajustar ao conteúdo
  bgcolor: 'background.default',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center', // Centralizando o texto
};

export const DeleteAlertModal = ({
  alertSelectedToBeDelete,
  handleClose,
  open,
  setAlertSelectedToBeDelete,
  setReload,
}) => {
  const [loading, setLoading] = useState(false);

  const DeleteAlert = async (event) => {
    setLoading(true);
    try {
      await deleteAlerts(alertSelectedToBeDelete);
      setAlertSelectedToBeDelete('');
      handleClose(event);
      setReload((prevReload) => !prevReload);
      toast.success('Alerta deletado com sucesso!');
    } catch (error) {
      toast.error('Algo não funcionou corretamente, tente novamente mais tarde.');
      console.log('ERROR AO DELETAR ALERTA ==> ', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <X size={20} weight="bold" />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" color="text.primary" sx={{ mb: 2, mt: 4 }}>
          Tem certeza que deseja deletar esse alerta?
        </Typography>
        <Box display="flex" justifyContent="center" mt={2} gap={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => DeleteAlert(event)}
            sx={{ minWidth: '5rem' }}
          >
            {loading ? (
              <CircularProgress size={25} thickness={5} sx={{ color: '#fff' }} />
            ) : (
              'Deletar'
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
